import { render, staticRenderFns } from "./AgendaSpecializzazioniListPage.vue?vue&type=template&id=3bb4abf9&scoped=true"
import script from "./AgendaSpecializzazioniListPage.vue?vue&type=script&lang=js"
export * from "./AgendaSpecializzazioniListPage.vue?vue&type=script&lang=js"
import style0 from "./AgendaSpecializzazioniListPage.vue?vue&type=style&index=0&id=3bb4abf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb4abf9",
  null
  
)

export default component.exports